import WaveSurfer from 'wavesurfer.js'
;(() => {
    const allPlayers = []

    document.querySelectorAll('.js-connection-entry-audio').forEach(audioBlock => {
        const mediaFilePath = audioBlock.dataset.audioSrc
        const playButtons = audioBlock.querySelectorAll('.lead-contact-entry__play')
        // const durationNode = audioBlock.querySelector('.lead-contact-entry__audio-duration')
        const waveSurferEl = audioBlock.querySelector('.lead-contact-entry__wavesurfer')
        let waveSurfer = null
        
        let ready = false

        const playButtonPlayingClass = 'lead-contact-entry__play_playing'

        createAudio()

        // window.addEventListener('tab-event', e => {
        //     if (e.tabsGroup == 'lead' && e.tabIndex == 1) {
        //         reCreateAudio()
        //     }
        // })

        window.addEventListener('complex-lead-stack-open', event => {
            const { targetName } = event
            if (targetName === 'contact') {
                reCreateAudio()
            }
        })

        playButtons.forEach(playButton => {
            playButton.addEventListener('click', e => {
                e.preventDefault()

                if (!ready || !waveSurfer) return

                if (waveSurfer.isPlaying()) {
                    waveSurfer.pause()
                    playButtons.forEach(button => {
                        button.classList.remove(playButtonPlayingClass)
                    })
                } else {
                    pauseAllPlayers()
                    waveSurfer.play()
                    playButtons.forEach(button => {
                        button.classList.add(playButtonPlayingClass)
                    })
                }
            })
        })
        
        function createAudio() {
            waveSurfer = new WaveSurfer.create({
                container: waveSurferEl,
                barWidth: 2,
                barHeight: 1,
                barGap: 1,
                height: 30,
                waveColor: '#ddd',
                progressColor: '#595959',
                cursorColor: 'transparent',
                responsive: true
            })

            waveSurfer.playButtons = playButtons

            allPlayers.push(waveSurfer)
    
            waveSurfer.load(mediaFilePath)

            waveSurfer.on('ready', () => {
                ready = true

                updateDuration()
            })
        }

        function reCreateAudio() {
            if (waveSurfer) waveSurfer.destroy()

            playButtons.forEach(button => {
                button.classList.remove(playButtonPlayingClass)
            })

            ready = false

            createAudio()
        }

        function updateDuration() {
            if (!waveSurfer || !durationNode) return
            const duration = waveSurfer.getDuration()
            durationNode.innerHTML = formatTextToTime(duration)
        }

        function formatTextToTime(time) {
            const hours = parseInt(time / 3600)
            const minutes = parseInt((time - (hours * 3600)) / 60)
            const seconds = parseInt(time - hours * 3600 - minutes * 60)

            return `${leadingZero(hours)}:${leadingZero(minutes)}:${leadingZero(seconds)}`
        }

        function leadingZero(number) {
            return number > 9 ? number : `0${number}`
        }

        function pauseAllPlayers() {
            allPlayers.forEach(player => {
                player?.pause()
                player?.playButtons.forEach(button => {
                    button.classList.remove(playButtonPlayingClass)
                })
            })
        }
    })
})();